import actions from "./actions";

const {
  FETCH_ROOMS_BEGIN,
  FETCH_ROOMS_SUCCESS,
  FETCH_ROOMS_ERR,
  SELECT_ROOM,
  FETCH_MESSAGES_BEGIN,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_ERR,
  APPEND_MESSAGE,
  SEND_MESSAGE_BEGIN,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERR,
} = actions;

const initialState = {
  rooms: [],
  roomsLoading: false,
  roomsError: null,
  selectedRoom: null,
  messages: [],
  messagesLoading: false,
  messagesError: null,
  sending: false,
};

const ensureArray = (value) => (Array.isArray(value) ? value : []);

const messengerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROOMS_BEGIN:
      return { ...state, roomsLoading: true, roomsError: null };
    case FETCH_ROOMS_SUCCESS:
      return { ...state, roomsLoading: false, rooms: ensureArray(action.data) };
    case FETCH_ROOMS_ERR:
      return { ...state, roomsLoading: false, roomsError: action.err };

    case SELECT_ROOM:
      return { ...state, selectedRoom: action.room, messages: [] };

    case FETCH_MESSAGES_BEGIN:
      return { ...state, messagesLoading: true, messagesError: null };
    case FETCH_MESSAGES_SUCCESS:
      return { ...state, messagesLoading: false, messages: ensureArray(action.data) };
    case FETCH_MESSAGES_ERR:
      return { ...state, messagesLoading: false, messagesError: action.err };

    case APPEND_MESSAGE: {
      const existing = ensureArray(state.messages);
      // Sending your own message appends it optimistically (see sendJobMessage) instead of
      // waiting on the live socket to echo it back — if that publication does still arrive,
      // this dedupe by id keeps it from showing up twice.
      if (action.message?.id && existing.some((m) => m.id === action.message.id)) {
        return state;
      }
      return { ...state, messages: [...existing, action.message] };
    }

    case SEND_MESSAGE_BEGIN:
      return { ...state, sending: true };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sending: false };
    case SEND_MESSAGE_ERR:
      return { ...state, sending: false };

    default:
      return state;
  }
};

export default messengerReducer;
